import React, { useMemo } from "react";

const translations = {
    en: {
        title: "Usage Limits",
        usedLabel: "Used:",
        ofItems: (used, allowed) => `${used} of ${allowed} items`,
    },
    ru: {
        title: "Лимиты использования",
        usedLabel: "Использовано:",
        ofItems: (used, allowed) => `${used} из ${allowed} элементов`,
    },
    ua: {
        title: "Ліміти використання",
        usedLabel: "Використано:",
        ofItems: (used, allowed) => `${used} з ${allowed} елементів`,
    },
};

const getInitialLang = () => (localStorage.getItem("lang") || "en").toLowerCase();

const ProgressBar = ({ lang = getInitialLang() , used = 0, allowed = 0 }) => {
    //const lang = getInitialLang();
    const t = useMemo(() => translations[lang] || translations.en, [lang]);

    const safeUsed = Number(used) || 0;
    const safeAllowed = Number(allowed) || 0;
    const percentage = safeAllowed > 0 ? (safeUsed / safeAllowed) * 100 : 0;

    let barColor = "#4CAF50"; // green
    if (percentage >= 75) barColor = "#f20000"; // red
    else if (percentage >= 50) barColor = "#ff9a44"; // orange

    const usedPct = Math.min(100, Math.max(0, percentage));
    const unusedPct = 100 - usedPct;

    return (
        <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="card-title fw-semibold mb-0">{t.title}</h5>
                    <span className="badge bg-primary-subtle text-primary fw-semibold">
                        {t.ofItems(safeUsed, safeAllowed)}
                    </span>
                </div>

                <div className="d-flex justify-content-between mb-2 text-muted small">
                    <span>{t.usedLabel}</span>
                    <span>{usedPct.toFixed(0)}%</span>
                </div>

                <div
                    className="w-100 rounded-pill overflow-hidden"
                    style={{ height: 18, backgroundColor: "#eef1f4" }}
                >
                    <div
                        className="d-flex h-100"
                        style={{ width: "100%" }}
                    >
                        <div
                            style={{
                                width: `${usedPct}%`,
                                background: barColor,
                                transition: "width 0.3s ease",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: usedPct >= 10 ? "#fff" : "#fff",
                                fontSize: 10,
                                fontWeight: 700,
                            }}
                        >
                            {`${usedPct.toFixed(0)}%`}
                        </div>
                        <div
                            style={{
                                width: `${unusedPct}%`,
                                background: "#d9dce1",
                                transition: "width 0.3s ease",
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProgressBar;
